import React from "react";
import Div from "@jumbo/shared/Div";
import MobileCodeEditorAndOutputPanel from "components/CodeEditorAndOutput/MobileCodeEditorAndOutputPanel";

const MobileEditorPanel = ({
  code,
  setCode,
  editorLanguage,
  headerControls,
  codeTabs,
  outputTabs,
  outputContent,
  theme,
  codeTabValue,
  setCodeTabValue,
  ioTabValue,
  setOutputTabValue,
  handleIOTabChange,
}) => {
  return (
    <Div sx={{ display: "flex", height: "100%", overflowY: "auto" }}>
      <MobileCodeEditorAndOutputPanel
        code={code}
        setCode={setCode}
        editorLanguage={editorLanguage}
        headerControls={headerControls}
        codeTabs={codeTabs}
        outputTabs={outputTabs}
        outputContent={outputContent}
        theme={theme}
        codeTabValue={codeTabValue}
        setCodeTabValue={setCodeTabValue}
        ioTabValue={ioTabValue}
        setOutputTabValue={setOutputTabValue}
        handleIOTabChange={handleIOTabChange}
      />
    </Div>
  );
};

export default MobileEditorPanel;
